import React from "react";

const LoaderBar = ({ isUploading, uploadProgress = 0, progressLabel = "Uploading" }) => {
    if (!isUploading) return null;
    return (
        <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-[2px] flex flex-col items-center justify-center text-white">
            <div className="w-64 bg-gray-700 rounded-full h-2 mb-3 overflow-hidden">
                <div
                    className="bg-blue-400 h-2 transition-all duration-300"
                    style={{ width: `${uploadProgress}%` }}
                ></div>
            </div>
            <div className="text-sm">
                {uploadProgress < 100 ? `${progressLabel} ${uploadProgress}%` : "Processing..."}
            </div>
        </div>
    );
};

export default LoaderBar;